// extracted by mini-css-extract-plugin
export var drawerContent = "_3g-0";
export var valueBlock = "_3g-1";
export var valueBlockFrom = "_3g-2 _3g-1";
export var valueBlockTo = "_3g-3 _3g-1";